/**
 * Manages dynamic viewport height for experience sections.
 * Handles CSS variable updates on resize and orientation changes.
 */
class ViewportManager {
    constructor() {
        this.handleResize            = this.handleResize.bind(this);
        this.handleOrientationChange = this.handleOrientationChange.bind(this);
    }

    /**
     * Initialize viewport height and attach event listeners.
     */
    init() {
        this.updateViewportHeight();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleOrientationChange);
    }

    /**
     * Handle resize event.
     */
    handleResize() {
        this.updateViewportHeight();
    }

    /**
     * Handle orientation change event.
     */
    handleOrientationChange() {
        this.updateViewportHeight();
    }

    /**
     * Update CSS variable with current viewport height.
     */
    updateViewportHeight() {
        const docElement = document.documentElement;

        const candidates = [];

        if (typeof window.innerHeight === 'number') {
            candidates.push(window.innerHeight);
        }

        if (docElement && typeof docElement.clientHeight === 'number' && docElement.clientHeight > 0) {
            candidates.push(docElement.clientHeight);
        }

        if (window.visualViewport && typeof window.visualViewport.height === 'number') {
            candidates.push(window.visualViewport.height);
        }

        const viewportHeight = candidates.length > 0
            ? Math.min(...candidates)
            : window.innerHeight;

        const vh = viewportHeight * 0.01;

        docElement.style.setProperty('--experience-vh', `${vh}px`);
    }

    /**
     * Cleanup event listeners.
     */
    destroy() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    }
}

export default ViewportManager;
